import { createContext, useContext, useState, type ReactNode } from "react";
import type { ChatMessage } from "./types";

interface ChatContextValue {
  replyTarget: ChatMessage | null;
  setReplyTarget: (m: ChatMessage | null) => void;
}

const ChatContext = createContext<ChatContextValue | null>(null);

export function ChatProvider({ children }: { children: ReactNode }) {
  const [replyTarget, setReplyTarget] = useState<ChatMessage | null>(null);
  return (
    <ChatContext.Provider value={{ replyTarget, setReplyTarget }}>
      {children}
    </ChatContext.Provider>
  );
}

export function useChat() {
  const ctx = useContext(ChatContext);
  if (!ctx) throw new Error("useChat must be inside <ChatProvider>");
  return ctx;
}
